import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { heroSlides } from "../mock";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  const next = useCallback(() => setIndex((i) => (i + 1) % heroSlides.length), []);
  const prev = () => setIndex((i) => (i - 1 + heroSlides.length) % heroSlides.length);

  useEffect(() => {
    const t = setInterval(next, 6000);
    return () => clearInterval(t);
  }, [next]);

  return (
    <section className="relative h-[62vh] min-h-[440px] w-full overflow-hidden">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            i === index ? "opacity-100 z-10" : "opacity-0 z-0"
          }`}
        >
          <div
            className={`absolute inset-0 bg-cover bg-center ${i === index ? "animate-kenburns" : ""}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
          <div className="absolute inset-0 bg-[#0f6b82]/55" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/10 to-black/25" />

          {i === index && (
            <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
              <p className="font-heading text-white/90 text-sm md:text-base uppercase tracking-[0.4em] mb-4 animate-fade-up">
                {slide.kicker}
              </p>
              <h1
                className="font-heading text-white text-5xl md:text-7xl font-light uppercase tracking-[0.08em] mb-10 animate-fade-up"
                style={{ animationDelay: "0.12s" }}
              >
                {slide.title}
              </h1>
              <Link
                to={slide.ctaPath}
                className="font-heading uppercase tracking-[0.2em] text-sm text-white border border-white/70 px-10 py-4 hover:bg-white hover:text-[#0f6b82] transition-all duration-300 animate-fade-up"
                style={{ animationDelay: "0.24s" }}
              >
                {slide.cta}
              </Link>
            </div>
          )}
        </div>
      ))}

      {/* Arrows */}
      <button
        onClick={prev}
        aria-label="Previous slide"
        className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 z-20 text-white/70 hover:text-white transition-colors"
      >
        <ChevronLeft size={40} strokeWidth={1.5} />
      </button>
      <button
        onClick={next}
        aria-label="Next slide"
        className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 z-20 text-white/70 hover:text-white transition-colors"
      >
        <ChevronRight size={40} strokeWidth={1.5} />
      </button>

      {/* Dots */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-3">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            aria-label={`Go to slide ${i + 1}`}
            onClick={() => setIndex(i)}
            className={`h-2.5 rounded-full transition-all duration-300 ${
              i === index ? "w-8 bg-white" : "w-2.5 bg-white/50 hover:bg-white/80"
            }`}
          />
        ))}
      </div>
    </section>
  );
}
